import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import axios from "axios";

import "react-big-calendar/lib/css/react-big-calendar.css";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import UiContent from "../../Components/Common/UiContent";
import EventModal from "./EventModal";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { useSelector } from "react-redux";
import EventNoteModal from "./EventNoteModal";

const localizer = momentLocalizer(moment);

export default function Events() {
  const [events, setEvents] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [filtermealperiod, setFiltermealperiod] = useState([]);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [editingNote, setEditingNote] = useState(false);
  const [noteData, setNoteData] = useState(null);

  const {
      mealperiod,
    } = useSelector((state) => ({
      mealperiod: state.Dashboard.filterData.mealperiod || [],
    }));

  // ✅ LOAD EVENTS FROM API
  useEffect(() => {
    fetchEvents(currentDate);
    }, []);

    useEffect(() => {
        if (mealperiod) {
          setFiltermealperiod(mealperiod);
        }
        console.log(mealperiod);
        
      }, [mealperiod]);

    const handleNavigate = (date) => {
    setCurrentDate(date);
    fetchEvents(date);
    };

  const fetchEvents = async (date) => {
    try {
        setLoading(true);

        const { start, end } = getMonthRange(date);

        const response = await postDataAPI({
            serviceName: "service_period_data",
            op: "event_sp_listing",
            from_dt: start,
            to_dt: end
        });

        if (response.status === "ok") {

            const grouped = {};

            const eventsData = response.data || [];

            eventsData.forEach(ev => {
              const desc = ev.description || {};
              const eventId = desc.event_id;

              if (!grouped[eventId]) {
                grouped[eventId] = {
                  id: "event-" + eventId,
                  title: desc.event_name,
                  start: new Date(desc.from_dt),
                  end: moment(desc.to_dt).add(1, "day").toDate(),
                  allDay: true,
                  type: "event",
                  className: "calendar-event",
                  resource: desc
                };
              }
            });

            const formatted = Object.values(grouped);

            const groupedNotes = {};

            (response.notes || []).forEach(note => {

              const noteId = note.note_id;

              if (!groupedNotes[noteId]) {

                groupedNotes[noteId] = {
                  id: "note-" + noteId,
                  title: note.note_title,
                  start: new Date(note.start_date),
                  end: moment(note.end_date).add(1, "day").toDate(),
                  allDay: true,
                  type: "note",
                  className: "calendar-note",
                  resource: note
                };

              }

            });

            const notesList = Object.values(groupedNotes);

            // ✅ MERGE EVENTS + NOTES
            setEvents([...formatted, ...notesList]);
        }

    } catch (err) {
        console.error("Error loading events", err);
    } finally {
        setLoading(false);
    }
    };

  const getMonthRange = (date) => {
    const start = moment(date).startOf("month").format("YYYY-MM-DD");
    const end = moment(date).endOf("month").format("YYYY-MM-DD");
    return { start, end };
    };

  // ✅ ADD NEW EVENT
  const handleAddClick = () => {
    setEditing(false);
    setEventData(null);
    setModalOpen(true);
  };

  // ✅ EDIT EVENT
  // const handleSelectEvent = (event) => {
  //   setEditing(true);
  //   setEventData(event);
  //   setModalOpen(true);
  // };
  const handleSelectEvent = (event) => {

    if (event.type === "note") {
      setNoteData(event.resource);
      setEditingNote(true);
      setNoteModalOpen(true);
    } else {
      setEditing(true);
      setEventData(event);
      setModalOpen(true);
    }
  };

  const handleSave = async (formData) => {
    try {
      setLoading(true);

      const isEdit = editing && eventData?.resource?.event_id;

      // 🔹 Convert days to numeric (1–7)
      const dayNumbers = formData.days.map(
        day => ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"].indexOf(day) + 1
      );

      // 🔹 Capacity arrays
      const seatArray = formData.capacity.map(row => Number(row.seats));
      const tableArray = formData.capacity.map(row => Number(row.tables));

      const totalTables = tableArray.reduce((a, b) => a + b, 0);
      const totalSeats = formData.capacity.reduce(
        (sum, row) => sum + (Number(row.seats) * Number(row.tables)),
        0
      );

      const formatTime = (date) =>
        date ? moment(date).format("HH:mm:ss") : "";

      const payload = {
        serviceName: "service_period_data",

        // ✅ SWITCH OP BASED ON MODE
        op: isEdit
          ? "edit_event_sp_details"
          : "add_event_sp_details",

        // ✅ SEND event_id ONLY IN EDIT MODE
        ...(isEdit && {
          event_id: eventData.resource.event_id
        }),
        event_name: formData.name,
        from_dt: moment(formData.fromDate).format("YYYY-MM-DD"),
        to_dt: moment(formData.tillDate).format("YYYY-MM-DD"),

        _area: formData.closed ? "" : formData.area,
        area_unit: formData.closed ? "" : formData.areaUnit,

        start_time: formatTime(formData.startTime),
        end_time: formatTime(formData.endTime),
        dining_time: formData.closed ? "" : formData.duration,
        is_holiday: formData.closed ? 1 : 0,

        capacity: formData.closed
          ? ""
          : JSON.stringify({
              seats: seatArray,
              count: tableArray
            }),

        applicable_to: JSON.stringify({
          [formData.servicePeriod]: {
            days: dayNumbers,
            start_time: formatTime(formData.startTime),
            end_time: formatTime(formData.endTime)
          }
        }),

        total_tables: totalTables,
        total_seats: totalSeats,

        event_note: formData.notes,
        impacts_forecast: formData.impact
      };

      console.log("Final Payload:", payload);

      const response = await postDataAPI(payload);

      if (response.status === "ok") {
        fetchEvents(currentDate);
        setModalOpen(false);
        setEventData(null);
        setEditing(false);
      }

    } catch (err) {
      console.error("Save error", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      if (!eventData?.resource?.event_id) return;

      const confirmDelete = window.confirm("Are you sure you want to delete this event?");
      if (!confirmDelete) return;

      setLoading(true);

      const payload = {
        serviceName: "service_period_data",
        op: "delete_event",
        event_id: eventData.resource.event_id
      };

      const response = await postDataAPI(payload);

      if (response.status === "ok") {
        fetchEvents(currentDate);
        setModalOpen(false);
        setEventData(null);
        setEditing(false);
      }

    } catch (err) {
      console.error("Delete error", err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddNote = () => {
    setEditingNote(false);
    setNoteData(null);
    setNoteModalOpen(true);
  };
  const handleSaveNote = async (formData) => {
    try {
      setLoading(true);

      const isEdit = editingNote && noteData?.note_id;

      const payload = {
        serviceName: "service_period_data",
        op: isEdit ? "update_event_note" : "add_event_note",

        ...(isEdit && { note_id: noteData.note_id }),
        note_title: formData.title,
        note_description: formData.note,
        from_dt: moment(formData.fromDate).format("YYYY-MM-DD"),
        to_dt: moment(formData.toDate).format("YYYY-MM-DD")
      };

      const response = await postDataAPI(payload);

      if (response.status === "ok") {
        fetchEvents(currentDate);
        setNoteModalOpen(false);
      }

    } catch (err) {
      console.error("Note save error", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteNote = async () => {
    if (!noteData?.note_id) return;

    const confirmDelete = window.confirm("Delete this note?");
    if (!confirmDelete) return;

    try {
      setLoading(true);

      const payload = {
        serviceName: "service_period_data",
        op: "delete_event_note",
        note_id: Number(noteData.note_id)
      };

      const response = await postDataAPI(payload);

      if (response.status === "ok") {
        fetchEvents(currentDate);
        setNoteModalOpen(false);
      }

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const eventStyleGetter = (event) => {

    if (event.type === "note") {
      return {
        style: {
          backgroundColor: "#099885",
          borderRadius: "4px",
          color: "#fff",
          border: "none"
        }
      };
    }

    return {
      style: {
        backgroundColor: "#364574",
        borderRadius: "4px",
        color: "#fff",
        border: "none"
      }
    };
  };

  const handleDuplicate = () => {

    if (!eventData) return;

    // create copy of event
    const duplicateEvent = {
      ...eventData,
      resource: {
        ...eventData.resource
      }
    };

    // remove id so it becomes new event
    delete duplicateEvent.resource.event_id;

    setEditing(false);      // switch to add mode
    setEventData(duplicateEvent);
    setModalOpen(true);
  };

  return (
    <>
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Event Management" pageTitle="Dashboard" />

          <Row className="mb-2">
            <Col className="text-end">
            <Button color="success" className="me-2" onClick={handleAddNote}>
              + Add Note
            </Button>
              <Button color="primary" onClick={handleAddClick}>
                + Add Event
              </Button>
            </Col>
          </Row>

          <div style={{ height: "75vh", background: "#fff", padding: 10 }}>
            
            <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                view="month"
                date={currentDate}
                onNavigate={handleNavigate}
                views={["month"]}
                selectable={false}
                onSelectEvent={handleSelectEvent}
                eventPropGetter={eventStyleGetter}
                popup
            />
          </div>

          {/* <EventModal
            isOpen={modalOpen}
            toggle={() =>{ setModalOpen(false); setEventData(null);}}
            editing={editing}
            initialData={eventData}
            servicePeriods={filtermealperiod}
            onSave={handleSave}
            loading={loading}
            onDelete={handleDelete}
          /> */}
          <EventModal
            isOpen={modalOpen}
            toggle={() =>{ setModalOpen(false); setEventData(null);}}
            editing={editing}
            initialData={eventData}
            servicePeriods={filtermealperiod}
            onSave={handleSave}
            loading={loading}
            onDelete={handleDelete}
            onDuplicate={handleDuplicate}
          />

          <EventNoteModal
            isOpen={noteModalOpen}
            toggle={() => setNoteModalOpen(false)}
            editing={editingNote}
            initialData={noteData}
            onSave={handleSaveNote}
            onDelete={handleDeleteNote}
            loading={loading}
          />
        </Container>
      </div>
    </>
  );
}